function toggleBurger($burger){
    if($burger.hasClass("is-active")){
        $burger.removeClass("is-active")
    }else{
        $burger.addClass("is-active")
    }
}

function openBurger($burger){
    $burger.addClass("is-active")
}

function closeBurger($burger){
    $burger.removeClass("is-active")
}